module.exports = __webpack_public_path__ + "static/media/50017.08807b1a.png";